<template>
  <div class="card my-3 px-3 py-3" style="width: 46%">
    <h3 style="color: #000; text-align: center">
      <i class="fas fa-phone-alt"></i> Ligações Atendidas
    </h3>
    <hr />
    <apexchart
      type="donut"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>

export default {
  props: ["filter"],
  data() {
    return {
      chartOptions: {
        chart: {
          id: "pizzaChartAnswered",
          type: "donut",
          toolbar: {
            show: true,
            tools: {
              download: true, // Ativa SVG, PNG, CSV
            }
          }
        },
        dataLabels: {
          offsetX: 50,
          offsetY: 2,
          style: {
            fontSize: "1.5em",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: "1.8em",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Total",
                  fontSize: "1.8em",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  color: "#373d3f",
                },
              },
            },
          },
        },
        labels: ["Até 1 min de espera", "Maior 1 min de espera"],
        colors: ["#00E396", "#FF4560"],
      },
      series: [],
    };
  },
  methods: {
    getCalls() {
      axios
        .get(`${window.location.href}/answeredCallsPizzaChart?queue=${this.filter}`)
        .then(({ data }) => {
          this.series = [data.Menor1minEspera, data.Maior1minEspera];
        });
    },
  },
  created() {
    this.getCalls();
    setInterval(() => {
      this.getCalls();
    }, 30000);
  },
  watch: {
    filter() {
      this.getCalls();
    }
  }
};
</script>

<style>
.apexcharts-menu {
  min-width: 160px !important;
  border: 1px solid #ddd !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 4px 0 !important;
  z-index: 9999 !important;
  font-family: "Segoe UI", Roboto, Arial, sans-serif !important;
}

.apexcharts-menu-item {
  color: #333 !important;
  font-size: 12px !important;
  padding: 10px 16px !important;
  transition: background 0.3s, color 0.3s !important;
  border-bottom: none !important;
}

.apexcharts-menu-item:hover {
  background-color: #f3f4f6 !important;
  color: #1a73e8 !important;
  cursor: pointer;
}

</style>